var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.phoneData),function(item,index){return (index < 2)?[_c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"mb-1 badge badge-round badge-light"},[_vm._v(_vm._s(item.value))])])]:_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }